import {
	getUserSubscriptionInYdr,
	subscribeUserInYdr,
} from "~/common/services/newsletter.service";

export const getFirebaseAuth = async () => {
	const { getApps, initializeApp } = await import("firebase/app");
	const { getAuth } = await import("firebase/auth");
	const firebaseConfig = await import("@/config/firebaseConfig");

	if (!getApps().length) {
		initializeApp(firebaseConfig.default);
	}

	return getAuth();
};

export const logOut = async () => {
	const auth = await getFirebaseAuth();
	await auth.signOut();
};

export const observeUserStateChanges = (callbackFunction) => {
	getFirebaseAuth()
		.then((auth) => {
			auth.onAuthStateChanged((user) => {
				callbackFunction(user);
			});
		})
		.catch(console.error);
};

export const setPersistenceLevel = async () => {
	const auth = await getFirebaseAuth();
	const { browserLocalPersistence, GoogleAuthProvider, signInWithPopup } =
		await import("firebase/auth");
	return auth
		.setPersistence(browserLocalPersistence)
		.then(() => {
			const provider = new GoogleAuthProvider();
			provider.addScope("profile");
			provider.addScope("email");

			return signInWithPopup(auth, provider);
		})
		.catch((error) => {
			throw error;
		});
};

export const fetchClaims = async () => {
	const auth = await getFirebaseAuth();
	auth.currentUser.getIdTokenResult(true).then((idTokenResult) => {
		const hasUsPrivacy =
			idTokenResult.claims && idTokenResult.claims.usprivacy;
		return hasUsPrivacy;
	});
};

export const fetchUserPreferences = async (axios, config) => {
	const auth = await getFirebaseAuth();
	return auth.currentUser.getIdToken().then((idToken) => {
		return axios
			.get(`${config.API_SERVICE_AUTH}/preferences`, {
				headers: { Authorization: `Bearer ${idToken}` },
			})
			.then((response) => {
				return response;
			})
			.catch((err) => {
				console.error(
					"Could not connect to the preferences endpoint",
					err
				);
			});
	});
};

export const updateNewsletterSubscription = async (axios, config, params) => {
	const auth = await getFirebaseAuth();
	return auth.currentUser.getIdToken().then((idToken) => {
		subscribeUserInYdr(axios, config, params, idToken).catch((err) => {
			console.error("Could not connect to the newsletter endpoint", err);
		});
	});
};

export const getNewslettersSubscription = async (axios, config) => {
	const auth = await getFirebaseAuth();
	return auth.currentUser.getIdToken().then((idToken) => {
		return getUserSubscriptionInYdr(axios, config, idToken).catch((err) => {
			console.error(err);
		});
	});
};

export const putUserPreferences = async (axios, config, preferences) => {
	const auth = await getFirebaseAuth();
	return auth.currentUser.getIdToken().then((idToken) => {
		return axios
			.put(`${config.API_SERVICE_AUTH}/preferences`, preferences, {
				headers: { Authorization: `Bearer ${idToken}` },
			})
			.then(() => {})
			.catch((err) => {
				console.error(
					"Could not connect to the preferences endpoint",
					err
				);
			});
	});
};
